import { nip19 } from 'nostr-tools';
import { useParams, useNavigate } from 'react-router-dom';
import NotFound from './NotFound';
import { VideoDetailPage } from './VideoDetailPage';
import { ProfilePage } from './ProfilePage';
import { CollectionPage } from './CollectionPage';

export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();
  const navigate = useNavigate();

  if (!identifier) {
    return <NotFound />;
  }

  let decoded;
  try {
    decoded = nip19.decode(identifier);
  } catch {
    return <NotFound />;
  }

  const { type, data } = decoded;

  // Profile views - delegate to ProfilePage
  if (type === 'npub') {
    return <ProfilePage pubkey={data} />;
  }

  if (type === 'nprofile') {
    return <ProfilePage pubkey={data.pubkey} />;
  }

  // Video/event views - delegate to VideoDetailPage
  if (type === 'note') {
    return <VideoDetailPage eventId={data} />;
  }

  if (type === 'nevent') {
    return <VideoDetailPage eventId={data.id} />;
  }

  // Addressable events
  if (type === 'naddr') {
    const { pubkey, kind, identifier: d } = data;

    // Kind 30005 = Video collections (NIP-51 curation sets for videos)
    if (kind === 30005) {
      // Redirect to the proper collection URL structure
      const npub = nip19.npubEncode(pubkey);
      navigate(`/collection/${npub}/${d}`, { replace: true });
      return null;
    }

    return (
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold mb-4">Addressable Event</h1>
        <p className="text-muted-foreground">
          Kind {kind} with d-tag "{d}" by {pubkey.slice(0, 8)}...
        </p>
      </div>
    );
  }

  return <NotFound />;
}